/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import ChainingAddServices from './ChainingAddServices.vue'

export * from './ChainingAddServices'
export default ChainingAddServices
